// extracted by mini-css-extract-plugin
export default {"inputWrapper":"PidI98WzoPV_LRI0ve07"};